import React, { useEffect } from 'react'
import InsightDetailWrapper from './components/tmp-wrapper'
import { useAppContext } from '../../common/context';
import {useParams } from 'react-router-dom';
import { getArticleCategory, getArticleInfo, renameCategory } from '../../common/utils';

function Article() {
  const {slug} = useParams();
  const { insightTab, tabHandler } = useAppContext();
  useEffect(() => {
    const cat = getArticleCategory(slug);
    
    if (cat) {
      const name = renameCategory(cat);
      tabHandler(name);
    }
  },[slug]);
  
  const newSlug = "/"+slug;
  
  const data = getArticleInfo(newSlug);
  
  return (
    <InsightDetailWrapper data={data} module={insightTab} />
  )
}

export default Article